// src/pages/Home.tsx
import React from 'react';

import HomeSection from '../components/Sections/HomeSection';
import AboutSection from '../components/Sections/AboutSection';
import SolutionsSection from '../components/Sections/Services';
import ContactSection from '../components/Sections/contact'
const Home = () => {
  return (
    <>
      <HomeSection />
      <AboutSection />
       <SolutionsSection />
      <ContactSection />
     
    </>
  );
};

export default Home;